import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

export default function Termini() {
  return (
    <div className="min-h-screen">
      <Seo
        title="Termini e Condizioni"
        description="Termini e condizioni d'uso del sito dailybrickdeals.com."
        path="/termini"
      />
      <Header />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link
          to="/"
          data-testid="termini-back"
          className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-8"
        >
          <ArrowLeft size={14} /> Home
        </Link>

        <div className="font-mono-bdd text-xs uppercase tracking-[0.3em] text-[#FBD51C] mb-3">
          Legale
        </div>
        <h1 className="font-display font-black text-4xl text-white mb-8 tracking-tight">
          Termini e Condizioni
        </h1>

        <div className="prose prose-invert max-w-none space-y-5 text-zinc-300 text-sm leading-relaxed">
          <p>Benvenuto in <strong>dailybrickdeals.com</strong>!</p>
          <p>
            Questi termini e condizioni illustrano le regole e i regolamenti per l&apos;uso del sito web
            dailybrickdeals, situato su{" "}
            <a href="https://dailybrickdeals.com/" className="text-[#FBD51C]">https://dailybrickdeals.com/</a>.
          </p>
          <p>
            Accedendo a questo sito web presumiamo che accetti questi termini e condizioni. Non continuare
            a utilizzare dailybrickdeals.com se non accetti tutti i termini e condizioni indicati in questa
            pagina.
          </p>
          <p>
            La seguente terminologia si applica a questi Termini e Condizioni, alla Dichiarazione di Privacy,
            alla Comunicazione di Disclaimer e a tutti gli Accordi: &laquo;Cliente&raquo;, &laquo;Tu&raquo;
            e &laquo;Tuo&raquo; si riferiscono a te, la persona che accede a questo sito web e che rispetta i
            termini e condizioni della Società. &laquo;La Compagnia&raquo;, &laquo;Noi Stessi&raquo;,
            &laquo;Noi&raquo;, &laquo;Nostri&raquo; e &laquo;Ci&raquo; si riferiscono alla nostra Azienda.
            &laquo;Parte&raquo;, &laquo;Parti&raquo; o &laquo;Noi&raquo; si riferisce sia al Cliente che a
            noi stessi. Tutti i termini si riferiscono all&apos;offerta, accettazione e contropartita del
            pagamento necessari per intraprendere il processo di assistenza al Cliente nel modo più
            appropriato al fine esplicito di soddisfare le esigenze del Cliente riguardo alla fornitura dei
            servizi dichiarati dalla Società, in conformità e soggetta alla legge vigente su di noi.
            Qualsiasi uso della terminologia sopra menzionata o di altre parole al singolare, plurale,
            maiuscole e/o lui/lei o loro è considerato intercambiabile e quindi come riferimento a esso.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Cookie</h2>
          <p>
            Utilizziamo i cookie. Accedendo a dailybrickdeals.com, hai accettato di utilizzare i cookie in
            accordo con l&apos;Informativa sulla Privacy di dailybrickdeals.
          </p>
          <p>
            La maggior parte dei siti interattivi utilizza i cookie per permetterci di recuperare i dati
            dell&apos;utente per ogni visita. I cookie sono utilizzati dal nostro sito web per abilitare la
            funzionalità di alcune aree, facilitando così la visita delle persone del nostro sito. Alcuni
            dei nostri partner affiliati/pubblicitari potrebbero anche utilizzare cookie.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Licenza</h2>
          <p>
            Salvo diversa indicazione, dailybrickdeals e/o i suoi licenziatari detengono i diritti di
            proprietà intellettuale su tutto il materiale dailybrickdeals.com. Tutti i diritti di proprietà
            intellettuale sono riservati. Puoi accedervi da dailybrickdeals.com per uso personale, soggetto
            a restrizioni stabilite da questi termini e condizioni.
          </p>
          <p>Non devi:</p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Ripubblicare materiale da dailybrickdeals.com</li>
            <li>Vendere, noleggiare o sub-licenziare materiale da dailybrickdeals.com</li>
            <li>Riprodurre, duplicare o copiare materiale da dailybrickdeals.com</li>
            <li>Ridistribuire i contenuti da dailybrickdeals.com</li>
          </ul>
          <p>Il presente Accordo inizierà alla data in cui si attesta.</p>
          <p>
            Alcune parti di questo sito offrono agli utenti l&apos;opportunità di pubblicare e scambiare
            opinioni e informazioni in determinate aree del sito. dailybrickdeals non filtra, modifica,
            pubblica o revisiona i Commenti prima della loro presenza sul sito web. I commenti non
            riflettono le opinioni di dailybrickdeals, dei suoi agenti e/o affiliati. I commenti riflettono
            le opinioni della persona che pubblica le proprie opinioni. Nella misura consentita dalle leggi
            applicabili, dailybrickdeals non sarà responsabile per i Commenti né per qualsiasi
            responsabilità, danno o spesa causata e/o subita a seguito di qualsiasi uso e/o pubblicazione
            e/o apparizione dei Commenti su questo sito web.
          </p>
          <p>
            dailybrickdeals si riserva il diritto di monitorare tutti i Commenti e di rimuovere qualsiasi
            Commento che possa essere considerato inappropriato, offensivo o che possa causare violazione
            di questi Termini e Condizioni.
          </p>
          <p>Tu garantisci e rappresenti che:</p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Hai il diritto di pubblicare i Commenti sul nostro sito web e hai tutte le licenze e i consensi necessari per farlo.</li>
            <li>I Commenti non invadono alcun diritto di proprietà intellettuale, inclusi senza limitazioni il diritto d&apos;autore, brevetto o marchio di terze parti.</li>
            <li>I Commenti non contengono alcun materiale diffamatorio, offensivo, indecente o in altro modo illegale che rappresenti un&apos;invasione della privacy.</li>
            <li>I Commenti non saranno utilizzati per sollecitare o promuovere attività commerciali o personalizzate, né per presentare attività commerciali o illegali.</li>
          </ul>
          <p>
            Concedi a dailybrickdeals una licenza non esclusiva per utilizzare, riprodurre, modificare e
            autorizzare altri a usare, riprodurre e modificare qualsiasi tuo Commento in qualsiasi forma,
            formato o media.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Collegamento ipertestuale ai nostri contenuti</h2>
          <p>Le seguenti organizzazioni possono collegarsi al nostro sito web senza previa approvazione scritta:</p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Agenzie governative;</li>
            <li>Motori di ricerca;</li>
            <li>Organizzazioni giornalistiche;</li>
            <li>Distributori di directory online, allo stesso modo in cui fanno un collegamento ipertestuale ai siti web di altre aziende elencate;</li>
            <li>Aziende accreditate a livello di sistema, ad eccezione di organizzazioni non profit che sollecitano organizzazioni non profit, centri commerciali di beneficenza e gruppi di raccolta fondi benefici.</li>
          </ul>
          <p>
            Queste organizzazioni possono collegarsi alla nostra homepage, a pubblicazioni o ad altre
            informazioni sul sito web purché il link: (a) non sia in alcun modo ingannevole; (b) non
            implica falsamente sponsorizzazione, approvazione o approvazione della parte che collega e
            dei suoi prodotti e/o servizi; e (c) rientra nel contesto del sito della parte collegante.
          </p>
          <p>
            Possiamo considerare e approvare altre richieste di link dai seguenti tipi di organizzazioni:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Fonti di informazione per consumatori e/o aziende comunemente conosciute;</li>
            <li>Siti community &laquo;.com&raquo;;</li>
            <li>Associazioni o altri gruppi che rappresentano enti di beneficenza;</li>
            <li>Distributori di directory online;</li>
            <li>Portali internet;</li>
            <li>Studi di contabilità, avvocati e consulenza;</li>
            <li>Istituzioni educative e associazioni di categoria.</li>
          </ul>
          <p>
            Approveremo le richieste di link da queste organizzazioni se decidiamo che: (a) il link non ci
            porterà a guardare negativamente noi stessi o le nostre attività accreditate; (b)
            l&apos;organizzazione non ha precedenti negativi con noi; (c) il beneficio per noi derivante
            dalla visibilità dell&apos;hyperlink compensa l&apos;assenza di dailybrickdeals; e (d) il
            collegamento si trova nel contesto delle informazioni generali sulle risorse.
          </p>
          <p>
            Queste organizzazioni possono collegarsi alla nostra home page purché il link: (a) non sia in
            alcun modo ingannevole; (b) non implica falsamente sponsorizzazione, approvazione o
            approvazione della parte che collega e dei suoi prodotti o servizi; e (c) rientra nel contesto
            del sito della parte collegante.
          </p>
          <p>
            Se sei una delle organizzazioni elencate nel paragrafo precedente e sei interessato a
            collegarti al nostro sito web, devi informarci contattandoci tramite il canale Telegram{" "}
            <a href="https://t.me/BrickDailyDeals" target="_blank" rel="noopener noreferrer" className="text-[#FBD51C]">
              @BrickDailyDeals
            </a>. Includi il tuo nome, il nome della tua organizzazione, le informazioni di contatto così
            come l&apos;URL del tuo sito, un elenco di eventuali URL da cui intendi collegare al nostro
            sito e un elenco degli URL presenti sul nostro sito a cui vorresti collegarti. Aspetta 2-3
            settimane per una risposta.
          </p>
          <p>Le organizzazioni approvate possono collegare il nostro sito web come segue:</p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Con l&apos;uso del nostro nome aziendale;</li>
            <li>Utilizzando il localizzatore uniforme delle risorse collegato;</li>
            <li>Attraverso qualsiasi altra descrizione del nostro sito web collegato che abbia senso nel contesto e nel formato dei contenuti presenti sul sito della parte linkante.</li>
          </ul>
          <p>
            Non sarà permesso l&apos;uso del logo di dailybrickdeals o di altre opere d&apos;arte per il
            collegamento in caso di contratto di licenza di marchio.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">iFrames</h2>
          <p>
            Senza approvazione preventiva e permesso scritto, non puoi creare cornici intorno alle nostre
            pagine web che alterino in alcun modo la presentazione visiva o l&apos;aspetto del nostro sito
            web.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Responsabilità dei contenuti</h2>
          <p>
            Non ci assumeremo la responsabilità di alcun contenuto che appare sul tuo sito web. Accetti di
            proteggerci e difenderci da tutte le accuse che emergono sul tuo sito web. Nessun link deve
            apparire su alcun sito web che possa essere interpretato come diffamatorio, osceno o
            criminale, o che violi, violi o promuova la violazione o altra violazione di diritti di terzi.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Riserva dei diritti</h2>
          <p>
            Ci riserviamo il diritto di richiedere la rimozione di tutti i link o di qualsiasi link
            particolare al nostro sito web. Autorizzi la rimozione immediata di tutti i link al nostro
            sito web su richiesta. Ci riserviamo inoltre il diritto di modificare questi termini e
            condizioni e la sua politica di collegamento in qualsiasi momento. Collegando continuamente il
            nostro sito web, accetti di essere vincolato e a seguire questi termini e condizioni di
            collegamento.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Rimozione dei link dal nostro sito web</h2>
          <p>
            Se trovi un link sul nostro sito web che sia offensivo per qualsiasi motivo, sei libero di
            contattarci e informarci in qualsiasi momento. Prenderemo in considerazione richieste di
            rimozione dei link, ma non siamo obbligati a risponderti direttamente.
          </p>
          <p>
            Non garantiamo che le informazioni presenti su questo sito web siano corrette, né ne
            garantiamo la completezza o accuratezza; né promettiamo di garantire che il sito web rimanga
            disponibile o che il materiale presente sia mantenuto aggiornato.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Disclaimer</h2>
          <p>
            Nella massima misura consentita dalla legge applicabile, escludiamo tutte le dichiarazioni,
            garanzie e condizioni relative al nostro sito web e all&apos;uso di questo sito. Nulla in
            questo disclaimer farà:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Limitare o escludere la nostra o la tua responsabilità per morte o lesioni personali;</li>
            <li>Limitare o escludere la nostra o la tua responsabilità per frode o falsa dichiarazione;</li>
            <li>Limitare qualsiasi nostra o tua responsabilità in modo non consentito dalla legge applicabile;</li>
            <li>Escludere qualsiasi nostra o tua responsabilità che potrebbe non essere esclusa dalla legge applicabile.</li>
          </ul>
          <p>
            Le limitazioni e le proibizioni di responsabilità stabilite in questa Sezione e altrove in
            questo disclaimer: (a) sono soggette al paragrafo precedente; e (b) regolano tutte le
            responsabilità derivanti dal disclaimer, incluse quelle derivanti da contratto, in
            responsabilità civile e per violazione di un dovere statutario.
          </p>
          <p>
            Finché il sito web e le informazioni e i servizi presenti sono forniti gratuitamente, non
            saremo responsabili per alcuna perdita o danno di qualsiasi tipo.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Link affiliati</h2>
          <p>
            Il Sito contiene link affiliati ad <strong>Amazon</strong>, <strong>eBay</strong>,
            <strong> AliExpress</strong> e altri programmi di affiliazione. Cliccando su un link
            affiliato e completando un acquisto, il Sito può ricevere una commissione senza alcun costo
            aggiuntivo per te. In qualità di Affiliato Amazon, il Sito riceve guadagni dagli acquisti
            idonei.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Marchi di terzi</h2>
          <p>
            <strong>dailybrickdeals.com è un canale indipendente, non affiliato né sponsorizzato da The
            LEGO Group.</strong> Tutti i marchi citati (LEGO®, Star Wars™, Harry Potter™, Marvel™, ecc.)
            appartengono ai rispettivi titolari e sono menzionati esclusivamente a fini descrittivi.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">Contattarci</h2>
          <p>
            Per domande sui presenti Termini e Condizioni puoi contattarci tramite il canale Telegram{" "}
            <a href="https://t.me/BrickDailyDeals" target="_blank" rel="noopener noreferrer" className="text-[#FBD51C]">
              @BrickDailyDeals
            </a>{" "}
            o dalla pagina <Link to="/contatti" className="text-[#FBD51C]">Contatti</Link>.
          </p>

          <p className="text-zinc-500 pt-6 border-t border-zinc-800 mt-8">
            Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
